// extracted by mini-css-extract-plugin
export default {"order":"OrdersPage_order__b9Dot","load":"OrdersPage_load__MgxN-","loadmore":"OrdersPage_loadmore__jtarn"};